export const locales = ["fr", "en", "de"] as const;
export type Locale = (typeof locales)[number];
export const defaultLocale: Locale = "fr";

export function isLocale(value: string): value is Locale {
  return locales.includes(value as Locale);
}

export function getOtherLocales(current: Locale): Locale[] {
  return locales.filter((l) => l !== current);
}

export function localeToLanguageTag(locale: Locale): string {
  switch (locale) {
    case "fr":
      return "fr-FR";
    case "en":
      return "en-US";
    case "de":
    default:
      return "de-DE";
  }
}
